<template>
  <v-layout
    id="UserDashboard"
    column
    wrap
  >
    <v-flex
      v-if="user.subscription == 'standard'"
      xs12
    >
      <h2>Welkom op het Discussieplatform van <i>Geef ze de Vijf!</i></h2>

      <p>
        Je hebt gekozen voor een abonnement op het Discussieplatform voor
        Levensduurverlenging Melkvee. Als deelnemers heb je automatisch toegang
        tot het Kennis- en informatieplatform Levensduurverlenging Melkvee.
      </p>

      <p>
        Als melkveehouder kun je ook mee doen aan de bedrijfsvergelijking. Wij
        vragen je daarvoor een aantal bedrijfskengetallen in te vullen. Voor de
        huidige situatie en voor de situatie die je in de toekomst wilt
        bereiken. We berekenen op basis daarvan ook het levenssaldo voor de
        beide situaties. De ingevulde lijst van de huidige situatie wordt
        automatisch naar ons verstuurd zodat we kunnen meekijken of alles goed
        is ingevuld. Na deze check kun je de streefwaarden invullen. In het menu
        in de linker bovenhoek kun je kiezen voor het Discussieplatform, het
        Kennisplatform of om je profiel eventueel aan te passen.
      </p>

      <p>
        Wij wensen je een vruchtbaar gebruik van het platform en we horen graag
        als je eventuele suggesties hebt. Samen gaan we voor een gezonde en
        probleemloze veestapel met een lange levensduur.
      </p>

      <p>
        <b>Updates</b><br>
        Het platform wordt zo actueel mogelijk gehouden. Nieuwe informatie op
        het platform melden wij via onze nieuwsbrief. Meld je daarom ook aan
        voor de nieuwsbrief.
      </p>
    </v-flex>
    <v-flex
      v-if="user.subscription == 'watch'"
      xs12
    >
      <h2>Welkom op het Erfbetredersplatform van <i>Geef ze de Vijf!</i></h2>

      <p>
        Je hebt als erfbetreder gekozen voor deelname aan het discussieplatform.
        Ook jij kunt als leverancier en/of adviseur een rol spelen bij
        levensduurverlenging. Voorwaarde voor je inbreng is dat het om een
        inhoudelijke, niet-commerciële bijdrage gaat. Met een goede
        content-marketing kun je veel anderen bereiken. Wij kunnen ons
        voorstellen dat je daar vragen over hebt, dus bel, whatsapp of mail ons
        gerust, dan overleggen we even met je.
      </p>

      <p>
        Als erfbetreder heb je automatisch toegang tot het Kennis- en
        informatieplatform Levensduurverlenging Melkvee.
      </p>

      <p>
        In het menu in de linker bovenhoek kun je kiezen voor het
        discussieplatform, het kennisplatform of om je profiel eventueel aan te
        passen.
      </p>
      <p>
        Wij wensen je een vruchtbaar gebruik van het platform. Samen gaan we
        voor een gezonde en probleemloze veestapel met een lange levensduur.
      </p>

      <p>
        <b>Updates</b><br>
        Het platform wordt zo actueel mogelijk gehouden. Nieuwe informatie op
        het platform melden wij via onze nieuwsbrief. Meld je daarom ook aan
        voor de nieuwsbrief.
      </p>
    </v-flex>
    <v-flex
      v-if="user.subscription == 'student'"
      xs12
    >
      <h2>
        Welkom op het Kennis- en informatieplatform van <i>Geef ze de Vijf!</i>
      </h2>

      <p>
        Je hebt gekozen voor een abonnement op het Kennis- en informatieplatform
        Levensduurverlenging Melkvee. Daar lees je hoe je de levensduur van de
        veestapel kunt verlengen
      </p>

      <p>
        In het menu in de linker bovenhoek kun je kiezen voor het
        informatieplatform of om je profiel eventueel aan te passen.
      </p>

      <p>
        Wij wensen je een vruchtbaar gebruik van het platform. Samen gaan we
        voor een gezonde en probleemloze veestapel met een lange levensduur.
      </p>

      <p>
        <b>Updates</b><br>
        Het platform wordt zo actueel mogelijk gehouden. Nieuwe informatie op
        het platform melden wij via onze nieuwsbrief. Meld je daarom ook aan
        voor de nieuwsbrief.
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'SimpleUserDashboard',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  methods: {},
}
</script>

<style scoped>
p {
  font-size: 1.1rem;
}
h2 {
  margin-bottom: 20px;
}
</style>
